import { Component, Inject, OnInit, inject, DestroyRef } from '@angular/core';
import { PlansService } from '../../../services/api/plans.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { animate, style, transition, trigger } from '@angular/animations';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { Permission } from 'src/app/models/principal/permission';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
    selector: 'app-upgrade-plan-dialog',
    templateUrl: './upgrade-plan-dialog.component.html',
    styleUrls: ['./upgrade-plan-dialog.component.scss'],
    animations: [
        trigger('thankYouMessage', [
            transition(':enter', [
                style({ transform: 'translateX(200px)' }),
                animate('200ms ease-out', style({ transform: 'none' }))
            ])
        ])
    ],
    standalone: false
})
export class UpgradePlanDialogComponent implements OnInit {

  readonly enterpriseCardBenefits = [
    'CREATE_SERVICE',
    'THE_PLATFORM',
    'END_TO_END_TRACK',
    'NO_CAP_ON_SANDBOX'
  ];
  readonly sandboxBenefits = [
    'SANDBOX_TRIAL_PERIOD',
    'COMMITTED',
    'TEMENOS_IS',
    'CREATE_TRIAL_SERVICE'
  ];

  // TODO: where do we persist this?
  unlockRequestSent: boolean;
  hasCreateSandboxPermission: boolean;
private destroyRef = inject(DestroyRef);
  constructor(private plansService: PlansService,
    private authService: AuthService,
    public dialogRef: MatDialogRef<UpgradePlanDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any) {
  }

  ngOnInit(): void {
    this.hasCreateSandboxPermission = this.authService.hasPermission(Permission.CREATE_SANDBOX);
  }

  closeDialog(event: any): void {
    this.dialogRef.close(translate(event));
  }

  unlockEnterprise(): void {
    this.plansService.unlockEnterprise()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.unlockRequestSent = true);
  }
}
